import React from 'react'
import StarIcon from "../../../assets/Icons/StarIcon.js";
import LendingPartnerLogo from "../../../assets/Images/Dashboard/lending-partner-logo.png";
import Card from '../../../components/Card.js';
import Headings from '../../../components/Texts/Headings.js';
import Paragraphs from '../../../components/Texts/Paragraphs.js';
import Scroller from '../../../components/Slider/Scroller.js';

const loanService = [
  {
    title: "Loans For Your Urgent Needs",
    iconClass: "text-[#6F4C9F]",
    text: "Get Fast Approval in 10 Minutes!"
  },
  {
    title: "Get Instant Loans Up to 2L!",
    iconClass: "text-[#FECE07]",
    text: "5 Easy Steps to Your Loan!"
  }, {
    title: "Just a Simple Application",
    iconClass: "text-[#07B9AE]",
    text: "5 Easy Steps to Your Loan!"
  },
]
const AboutUsSection = () => {
  return (
    <div className="mt-[60px] md:mt-[180px] flex flex-col gap-[24px]">
      <div className="max-w-[1000px]">
        <Headings
          text="About Us"
        />
        <Paragraphs
          text="At FastFin, we recognize the challenges of unexpected expenses and aim to break through traditional banking barriers to provide timely. Whether it's an emergency expense or an opportunity that requires immediate funding, we help you navigate life's challenges with ease."
          className='mt-2'
        />
      </div>
      <div className="grid grid-cols-12">
        <div className="col-span-12 md:col-span-4 mt-2 md:mt-10">
          <div className="mb-[16px] md:mb-0">
            <p className="font-Apparat font-[700] text-[16px] md:text-[24px] lg:text-[32px]  leading-[32px] md:leading-[40px] tracking-[-2%]">Lending Partner</p>
            <img src={LendingPartnerLogo} className="mt-8" />
          </div>
        </div>
        <Scroller className={"col-span-12 md:col-span-8 flex gap-[20px]"}>
          {loanService?.map((item) => <Card className={"flex flex-col gap-[40px] min-w-[171px] pt-[40px] px-[12px] pb-[12px]"}>
            <StarIcon
              className={item?.iconClass}
              height='28'
              width='26.13'
            />
            <div className="flex flex-col gap-[12px]">
              <p className="font-Apparat font-[600] md:font-[700] text-[20px] lg:text-[24px] leading-[28px] md:leading-[32px] tracking-[-2%]">{item?.title}</p>
              <Paragraphs
                text={item.text}
                className='leading-[17.5px] text-[#42495299]'
              />

            </div>
          </Card>)}
        </Scroller>

      </div>
    </div>
  )
}

export default AboutUsSection